import { Award, ShieldCheck, Brain, Users, Star, IndianRupee, Briefcase, MapPin, TrendingUp, UserCog, Calendar, Smile, Compass } from "lucide-react";

// Employer -> Employee (8 functional criteria)
export const EMPLOYEE_CRITERIA = [
  { key: "performance", avgKey: "avg_performance", label: "Performance", icon: Award },
  { key: "character_score", avgKey: "avg_character", label: "Integrity", icon: ShieldCheck },
  { key: "ai_knowledge", avgKey: "avg_ai_knowledge", label: "Technical Skills", icon: Brain },
  { key: "teamwork", avgKey: "avg_teamwork", label: "Teamwork", icon: Users },
  { key: "attendance", avgKey: "avg_attendance", label: "Attendance", icon: Calendar },
  { key: "behaviour", avgKey: "avg_behaviour", label: "Behaviour", icon: Smile },
  { key: "leadership", avgKey: "avg_leadership", label: "Leadership", icon: Compass },
  { key: "reliability", avgKey: "avg_reliability", label: "Reliability", icon: Star },
];

// Employee -> Employer (5 functional criteria)
export const EMPLOYER_CRITERIA = [
  { key: "salary", avgKey: "avg_salary", label: "Salary Payment", icon: IndianRupee },
  { key: "environment", avgKey: "avg_environment", label: "Work Culture", icon: Briefcase },
  { key: "management", avgKey: "avg_management", label: "Management", icon: UserCog },
  { key: "growth", avgKey: "avg_growth", label: "Career Growth", icon: TrendingUp },
  { key: "location_score", avgKey: "avg_location", label: "Work-Life Balance", icon: MapPin },
];
